import type { OptionLabelPair } from '../../../../components/RadioGroup';
import type { BooleanFlag } from '../../../../types/boolean-flag';
import { BOOLEAN_FLAGS } from '../../../../types/boolean-flag';

export const AUTOMATICALLY_SYNC_INVOICES_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  { value: BOOLEAN_FLAGS.ENABLED, label: 'Automatically sync invoices upon approval (recommended)' },
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Do not sync automatically' },
];
